import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-justify-between tw-h-full tw-w-full wrapper" }
const _hoisted_3 = { class: "tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-[600] tw-leading-[130%] title" }
const _hoisted_4 = {
  key: 0,
  class: "tw-bg-[#211F58] tw-text-[11px] tw-font-medium tw-rounded tw-text-[#FFFFFF] tw-px-[5px] tw-py-[3px] tw-ml-[-4px] tw-w-fit"
}
const _hoisted_5 = { class: "tw-flex tw-gap-[15px] tw-items-center tw-w-full" }
const _hoisted_6 = {
  key: 0,
  class: "tw-text-[#878787] tw-text-[13px] tw-not-italic tw-font-[400]"
}

import get from "lodash/get";
import avatarStack from "../common/avatarStack.vue";
import userService from "@/services/user/userService";
import { IContributor } from "@/interfaces/assessments/IContributors";
import { PropType, Ref, onMounted, ref, watch } from "vue";
import { IApiPromise } from "@/interfaces/responseData";
import { IUserProfile, IUserProfileImage } from "@/interfaces/userInterfaces";
import { getChecklistContributors } from "@/services/assessment";
import { successStatusCodes } from "@/utils/constants";
import { showErrorAPI } from "@/services/apiRoutes";
import { UserRoute, Assessment } from "@/services/apiRoutes/routes";

import {} from "@/services/apiRoutes/routes";
import {
  getComponentUiText,
  getFullnamFromFirstAndLastName,
} from "@/utils/utilities";

export default /*#__PURE__*/_defineComponent({
  __name: 'contributorsCard',
  props: {
  checklistId: { type: Number, required: true },
  title: {
    type: String,
    default: getComponentUiText(
      "app-component-assessment-title-contributors-1",
    ),
  },
  listContributors: {
    type: Array as PropType<IContributor[]>,
    default: () => null,
  },
  id: {
    type: String,
    required: false,
    default: "",
  },
},
  emits: ["click"],
  setup(__props) {

const props = __props;




let contributors: IContributor[] = [];
let listProfile: IUserProfile[] = [];
let listAvatar: Ref<IUserProfileImage[]> = ref([]);
let userIds: string[] = [];

watch(
  () => props.checklistId,
  (value) => value && initial(),
);

watch(
  () => props.listContributors,
  (value) => value && initial(),
);

onMounted(() => initial());

const contributorNameOnHover: Ref<string> = ref("");

const initial = async () => {
  if (props.listContributors) {
    contributors = props.listContributors;
  } else {
    contributors = await getListContributor(props.checklistId);
    userIds = contributors.map((c) => c.userId);
    listProfile = await getUserProfile(userIds);

    // Get list image.
    const avatarImageFileIds = listProfile.map(
      (p) => p.avatar.avatarImageFileId,
    );
    listAvatar.value = await getListImageUser(avatarImageFileIds);
  }
  // Add default image if user have not.
  addDefaultImage();
};

const getListContributor = async (
  checklistId: number,
): Promise<IContributor[]> => {
  if (!checklistId || checklistId <= 0) return [];

  try {
    const res = await getChecklistContributors(checklistId);
    if (res.status !== successStatusCodes.OK) return [];

    const list = get(res, "data.data.contributors", []) as IContributor[];
    return list;
  } catch (error) {
    showErrorAPI(error, Assessment.getChecklistContributors);
    return [] as IContributor[];
  }
};

const getUserProfile = async (userIds: string[]) => {
  try {
    const listResult: IUserProfile[] = [];
    const promise: IApiPromise<IUserProfile>[] = [];
    userIds.map((u) => promise.push(userService.getUserProfile(u)));

    const resArray = await Promise.all(promise);
    resArray.forEach((res) =>
      listResult.push(get(res, "data.data", {} as IUserProfile)),
    );
    return listResult;
  } catch (error) {
    showErrorAPI(error, UserRoute.getUserProfile);
    return [];
  }
};

const getListImageUser = async (ids: number[]) => {
  const listResult: IUserProfileImage[] = [];
  const promise: IApiPromise<IUserProfileImage>[] = [];
  try {
    ids.forEach(
      (id) =>
        id && promise.push(userService.getUserProfileImage(id.toString())),
    );

    if (promise.length) {
      const listRes = await Promise.all(promise);
      listRes.forEach((r) =>
        listResult.push(get(r, "data.data", {} as IUserProfileImage)),
      );
      return listResult;
    }
  } catch (error) {
    showErrorAPI(error, UserRoute.getUserProfileImage);
    return [];
  }

  return [];
};

const fileImage = async (id: string) => {
  const res = await userService.getUserProfileImage(id);
  const data = get(res, "data.data", {} as IUserProfileImage);
  return data.file;
};

const addDefaultImage = async () => {
  Promise.all(
    contributors.map(async (c) => {
      const imageData = c.avatarImageId
        ? await fileImage(c.avatarImageId)
        : null;

      const avatar = listAvatar.value.find((a) => a.userId == c.userId);
      if (!avatar) {
        listAvatar.value.push({
          fileName: "",
          userId: c.userId,
          fileSize: 0,
          fileType: "",
          profileImageTypeId: 0,
          file: imageData,
          userName: getFullnamFromFirstAndLastName(c.firstName, c.lastName),
        });
      }
    }),
  );
};

const onHoverAvatar = (image: IUserProfileImage) => {
  if (Object.keys(image).length == 0) contributorNameOnHover.value = "";
  else {
    const contributor = contributors.find((x) => x.userId == image.userId);
    if (contributor)
      contributorNameOnHover.value =
        contributor.firstName + " " + contributor.lastName;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.id,
    class: "tw-bg-[#FCFCFC] tw-min-w-[284px] tw-max-w-[284px] tw-h-[112px] tw-w-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1]"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.title), 1),
      (contributorNameOnHover.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(contributorNameOnHover.value), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "tw-flex tw-w-full tw-cursor-pointer",
        onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('click'))
      }, [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(avatarStack, {
            avatars: _unref(listAvatar),
            "avatar-size": 32,
            "max-shown": 4,
            "onOn:hover": onHoverAvatar
          }, null, 8, ["avatars"]),
          (!__props.listContributors)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(contributors).length) + " " + _toDisplayString(__props.title), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})